import React from "react";
import SVGIconV3 from "../../common/SVGIcon/SVGIconV3";
import UserIconPostLoginMRGWrapper from "./UserIconPostLoginMRGWrapper";

const UserIconPostLoginMRG = () => {
  return (
    <UserIconPostLoginMRGWrapper>
      <SVGIconV3
        iconName="mrgreen-myaccount-area"
        width="63px"
        height="63px"
      ></SVGIconV3>
    </UserIconPostLoginMRGWrapper>
  );
};

export default UserIconPostLoginMRG;
